/* eslint-disable */
// @ts-nocheck
/*
* This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
*/

import * as fm from "../../fetch.pb"

export enum Policy {
  POLICY_UNSPECIFIED = "POLICY_UNSPECIFIED",
  OPTIONAL = "OPTIONAL",
  REQUIRED = "REQUIRED",
}

export type GetStatusRequest = {
}

export type GetStatusResponse = {
  enabled?: boolean
  policy?: Policy
  can_manage_policy?: boolean
  enforcement_active?: boolean
}

export type BeginEnrollmentRequest = {
}

export type BeginEnrollmentResponse = {
  enabled?: boolean
  policy?: Policy
  can_manage_policy?: boolean
  enforcement_active?: boolean
}

export type UpdatePolicyRequest = {
  policy?: Policy
}

export type UpdatePolicyResponse = {
  policy?: Policy
  reauthentication_required?: boolean
}

export type ResetUserRequest = {
  user_id?: string
}

export type ResetUserResponse = {
  removed_credentials?: number
}

export class MFAService {
  static GetStatus(req: GetStatusRequest, initReq?: fm.InitReq): Promise<GetStatusResponse> {
    return fm.fetchReq<GetStatusRequest, GetStatusResponse>(`/v1/auth/mfa?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static BeginEnrollment(req: BeginEnrollmentRequest, initReq?: fm.InitReq): Promise<BeginEnrollmentResponse> {
    return fm.fetchReq<BeginEnrollmentRequest, BeginEnrollmentResponse>(`/v1/auth/mfa/enrollment`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static UpdatePolicy(req: UpdatePolicyRequest, initReq?: fm.InitReq): Promise<UpdatePolicyResponse> {
    return fm.fetchReq<UpdatePolicyRequest, UpdatePolicyResponse>(`/v1/auth/mfa/policy`, {...initReq, method: "PUT", body: JSON.stringify(req, fm.replacer)})
  }
  static ResetUser(req: ResetUserRequest, initReq?: fm.InitReq): Promise<ResetUserResponse> {
    return fm.fetchReq<ResetUserRequest, ResetUserResponse>(`/v1/auth/mfa/users/${req["user_id"]}`, {...initReq, method: "DELETE"})
  }
}
